import React from 'react';
import SafeIcon from '../../../common/SafeIcon';

export default function DocumentationSection({ project }) {
  // Mock docs for now since we don't have a backend
  const docs = project.content?.documentation || [];

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-bold text-slate-900">Dokumentasjon</h2>
          <p className="text-sm text-slate-500">Filer, kontrakter og materiell</p>
        </div>
        <button className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors shadow-sm">
          <SafeIcon icon="➕" className="mr-2" /> Last opp fil
        </button>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        {docs.length > 0 ? (
          <ul className="divide-y divide-slate-100">
            {docs.map((doc, index) => (
              <li key={index} className="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 mr-4">
                    <SafeIcon icon="📄" />
                  </div>
                  <div>
                    <p className="font-medium text-slate-900">{doc.name}</p>
                    <p className="text-xs text-slate-500">{doc.date} • {doc.size}</p>
                  </div>
                </div>
                <button className="p-2 text-slate-400 hover:text-primary-600 transition-colors">
                  <SafeIcon icon="⬇️" />
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-slate-400">
            <SafeIcon icon="📂" className="w-16 h-16 mb-4 opacity-20" />
            <p className="mb-4">Ingen dokumenter lastet opp.</p>
            <button className="text-primary-600 font-medium hover:underline">
              Last opp første dokument
            </button>
          </div>
        )}
      </div>
    </div>
  );
}